import StockBrokerBanner from './StockBrokerBanner';
import StockBrokerSection from './StockBrokerSection';

function StockBroker() {
  return (
    <div>
      <StockBrokerBanner />
      <StockBrokerSection />
    </div>
  );
}

export default StockBroker;